module.exports = __webpack_public_path__ + "img/Plantas rebaixadas e com retirada de ramos laterais 5.955ada52.webp";